// extracted by mini-css-extract-plugin
module.exports = {"component":"util-IconLabel__component--3Uitr","svg":"util-IconLabel__svg--1Gmdo","label":"util-IconLabel__label--gSaB3"};